import { apiRoutes } from "../services/apiRoutes";
import { CustomerData } from './CustomerData';

// Drop localizations with no text, and reset the negative placeholder ids the UI assigns to
// newly added rows so the server treats them as inserts.
const cleanLocalizations = (localizations) => {
    let cleaned = [];
    for (const localization of localizations) {
        if (localization.columnLocalizationId < 0)
            localization.columnLocalizationId = 0;

        if (localization.localization)
            cleaned.push(localization);
    }
    return cleaned;
};

// Number one grid's columns from 1 and append them to customerColumns. Material and document
// columns are ordered independently, so this is called once per grid.
const collectCustomerColumns = (columns, customerColumns) => {
    let order = 1;
    for (const column of columns) {
        if (column.customerColumns.length === 0) {
            column.customerColumns.push({ ColumnId: column.columnId, columnLocalizations: [], customerColumnId: 0, Selected: column.alwaysShow });
        }
        if (column.customerColumns.length > 0) {
            const customerColumn = column.customerColumns[0];
            customerColumn.ColumnOrder = order;
            order++;
            customerColumn.columnLocalizations = cleanLocalizations(customerColumn.columnLocalizations);
            customerColumn.width = column.width;
            customerColumns.push(customerColumn);
        }
    }
};

export const SettingsData = (props) => {

    const SaveSettings = async (materialColumns, documentColumns, PhraseSections, TimezoneId, DateFormatId, defaultIngredientType, defaultSensitivity, preserveExisting, iaTextValue1Id, iaTextValue2Id, iaTextValue3Id, iaGeneratorPattern, CustomerName, appendDdiToMatSrcId, secondaryHeaderColumnId, tertiaryHeaderColumnId) => {
        const { processColumns } = CustomerData({ execute: props.execute, navigate: props.navigate });
        let customerColumns = [];
        collectCustomerColumns(materialColumns, customerColumns);
        collectCustomerColumns(documentColumns, customerColumns);

        let order = 1;
        PhraseSections.forEach(x => {
            x.children = null;
            x.SortOrder = order++;
            x.ShowInDetails = x.ShowInDetails ? 1 : 0;
        });

        let postData = {
            CustomerName: CustomerName.trim(),
            TimezoneId: TimezoneId ?? '',
            DateFormatId: DateFormatId ?? '',
            customerColumns: customerColumns,
            formType: defaultIngredientType,
            docSense: defaultSensitivity,
            preserveExisting: preserveExisting ? 1 : 0,
            appendDdiToMatSrcId: appendDdiToMatSrcId ? 1 : 0,
            iaTextValue1Id: iaTextValue1Id == null ? null : iaTextValue1Id.trim(),
            iaTextValue2Id: iaTextValue2Id == null ? null : iaTextValue2Id.trim(),
            iaTextValue3Id: iaTextValue3Id == null ? null : iaTextValue3Id.trim(),
            iaGeneratorPattern: iaGeneratorPattern,
            secondaryHeaderColumnId: secondaryHeaderColumnId ?? null,
            tertiaryHeaderColumnId: tertiaryHeaderColumnId ?? null,
            PhraseSections: PhraseSections
        };

        await props.execute("POST", apiRoutes.users.settings.save, postData);
        let cust = props.customer;
        cust.CustomerName = CustomerName;
        cust.TimezoneId = TimezoneId;
        cust.DateFormatId = DateFormatId;
        cust.IadefaultFormulaType = defaultIngredientType;
        cust.DefaultSensitivity = defaultSensitivity;
        cust.PreserveExistingSensitivities = preserveExisting ? 1 : 0;
        cust.AppendDdiToMatSrcId = appendDdiToMatSrcId ? 1 : 0;
        cust.IatextValue1Id = iaTextValue1Id;
        cust.IatextValue2Id = iaTextValue2Id;
        cust.IatextValue3Id = iaTextValue3Id;
        cust.IaidGeneratorPattern = iaGeneratorPattern;
        cust.SecondaryHeaderColumnId = secondaryHeaderColumnId ?? null;
        cust.TertiaryHeaderColumnId = tertiaryHeaderColumnId ?? null;
        cust.PhraseSections = PhraseSections;
        let columns = processColumns(materialColumns.concat(documentColumns), props.localizations, props.languageValue.localeId);
        cust.columns = columns;
        props.setcustomer(cust);

    };

    return {
        SaveSettings
    };
}